export default {
    slug: 'guestlists',
    title: 'Guestlists',
    visible: [
        'name',
        'date',
        'sum_pax_planned',
        'count_rsvps_confirmed'
    ],
    listview: 'GuestlistListView',
    locales: ['common'],
    columns: [
        {
            key: 'name',
            main: true
        }
    ],
    permanentFields: [
        'id',
        'settings_enable_seatplan',
        'seatplan_id'
    ],
    requiredTranslations: [
        'guestlists'
    ],
    alertOverrides: {
        bulkDelete: {
            message: 'guestlists.bulk_actions.delete.message'
        }
    },
    actions: {
        guestlist_grid_view: {
            title: 'To grid view',
            level: 'global',
            icon: 'fal fa-th',
            vm: 'goToGridView'
        }
    },
    tooltipColumns: [
        'custom_1',
        'custom_2',
        'custom_3',
        'custom_4',
        'custom_5',
        'custom_6',
        'custom_7',
        'custom_8',
        'custom_9',
        'custom_10',
        'custom_11',
        'custom_12',
        'custom_13',
        'custom_14',
        'custom_15',
        'custom_16',
        'custom_17',
        'custom_18',
        'custom_19',
        'custom_10',
        'custom_21',
        'custom_22',
        'custom_23',
        'custom_24',
        'custom_25',
        'custom_26',
        'custom_27',
        'custom_28',
        'custom_29',
        'custom_30'
    ]
}



// WEBPACK FOOTER //
// ./src/app/store/guestlists/state.js